/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SeriesWithRelations } from '../../models/series-with-relations';

export interface AdminFindById$Params {
  id: string;
}

export function adminFindById(http: HttpClient, rootUrl: string, params: AdminFindById$Params, context?: HttpContext): Observable<StrictHttpResponse<SeriesWithRelations>> {
  const rb = new RequestBuilder(rootUrl, adminFindById.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<SeriesWithRelations>;
    })
  );
}

adminFindById.PATH = '/admin/series/{id}';
